// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"nnn6lFMUNOZ8ANxMjCvx"};